@if (formArray && formArray.controls.length > 0) {
  <div>
    <div class="control">
      <div class="field is-grouped is-grouped-multiline">
        @for (userControl of formArray.controls; track userControl; let i = $index) {
          <div class="tags has-addons">
            @if (userControl.get('UserId')?.value != null) {
              <span class="user-text">
                <a class="tag">{{ userControl?.get('FirstName')?.value }} {{ userControl?.get('LastName')?.value }}</a>
                <a class="tag" (click)="removeUser(i)"><i class="fa fa-trash"></i></a>
              </span>
            }
          </div>
        }
        <div class="tags has-addons">
          @if (AllowCreateUser) {
            <a class="tag button is-primary" (click)="addUser()">Add</a>
          }
        </div>
      </div>
    </div>
    @for (userControl of formArray.controls; track userControl; let i = $index) {
      <div>
        @if (userControl.get('UserId')?.value == null) {
          <span class="user-text">
            <div class="addComponent">
              <app-userselector (UserIdChange)="UserChanged($event, userControl)" [AllowCreateUser]="AllowCreateUser"></app-userselector>
            </div>
          </span>
        }
      </div>
    }
  </div>
}
